import React from "react";
import { Box, Flex, Text, Heading, Button, VStack } from "@chakra-ui/react";
import Modal from "@components/common/Modal";
import { useSdkUtils } from "@hooks";

const EReportLimitModal = ({ isOpen, onClose }) => {
  const { openUrl } = useSdkUtils();

  const handleUpgradeClick = async () => {
    try {
      await openUrl(process.env.REACT_APP_STRIPE_PAYMENT_PAGE);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemindLater = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" showCloseButton={true}>
      <VStack spacing={6} p={6} align="center">
        {/* Premium Badge */}
        <Flex
          bg="rgba(250, 196, 0, 0.26)"
          borderRadius="32px"
          px={2}
          py={1}
          align="center"
          gap={2}
        >
          <Text fontSize="14px" color="#937300">👑</Text>
          <Text fontSize="12px" color="#937300" fontWeight="400">Premium</Text>
        </Flex>

        {/* Title */}
        <Heading
          as="h2"
          fontSize="24px"
          fontWeight="700"
          textAlign="center"
          color="#0C001C"
          lineHeight="1.33"
          letterSpacing="-0.04em"
        >
          Unlock Full E-Reports & Analytics?{" "}
          <Text as="span" color="#0C001C">Go PRO!</Text>
        </Heading>

        {/* Features Container */}
        <Box bg="#DBDAF5" borderRadius="24px" p={5} w="full">
          <Heading
            as="h3"
            fontSize="20px"
            fontWeight="700"
            color="#0C001C"
            mb={4}
          >
            Uncover key insights
          </Heading>

          <VStack spacing={3} align="stretch">
            {/* Feature 1 */}
            <Flex align="center" gap={3}>
              <Box
                w="40px"
                h="40px"
                bg="white"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="20px"
              >
                📊
              </Box>
              <Text fontSize="14px" color="#0C001C" fontWeight="400">
                Unlimited Full E-Reports
              </Text>
            </Flex>

            <Box w="full" h="0.5px" bg="#B7B5EB" ml="44px" />

            {/* Feature 2 */}
            <Flex align="center" gap={3}>
              <Box
                w="40px"
                h="40px"
                bg="white"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="20px"
              >
                📈
              </Box>
              <Text fontSize="14px" color="#0C001C" fontWeight="400">
                Advanced analytics & participant insights
              </Text>
            </Flex>

            <Box w="full" h="0.5px" bg="#B7B5EB" ml="44px" />

            {/* Feature 3 */}
            <Flex align="center" gap={3}>
              <Box
                w="40px"
                h="40px"
                bg="white"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="18px"
              >
                📑
              </Box>
              <Text fontSize="14px" color="#0C001C" fontWeight="400">
                CSV & PDF export for sharing
              </Text>
            </Flex>

            <Box w="full" h="0.5px" bg="#B7B5EB" ml="44px" />

            {/* Feature 4 */}
            <Flex align="center" gap={3}>
              <Box
                w="40px"
                h="40px"
                bg="white"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="18px"
              >
                🎯
              </Box>
              <Text fontSize="14px" color="#0C001C" fontWeight="400">
                Detailed activity impact breakdown
              </Text>
            </Flex>
          </VStack>

          {/* Info Box */}
          <Flex
            bg="#EDEDFA"
            borderRadius="12px"
            p={3}
            mt={4}
            align="center"
            gap={2}
          >
            <Box color="#0C001C" fontSize="24px">ℹ️</Box>
            <Text fontSize="14px" color="#433358" fontWeight="400">
              Boost attention and performance over time
            </Text>
          </Flex>
        </Box>

        {/* Action Buttons */}
        <VStack spacing={3} w="full">
          <Button
            bg="#4C47CC"
            color="white"
            fontSize="13px"
            fontWeight="700"
            h={12}
            w="full"
            borderRadius="8px"
            onClick={handleUpgradeClick}
            _hover={{ bg: "#3d38a6" }}
          >
            Upgrade to PRO
          </Button>

          <Button
            variant="ghost"
            color="#0C001C"
            fontSize="13px"
            fontWeight="700"
            onClick={handleRemindLater}
            _hover={{ bg: "gray.50" }}
          >
            Remind me Later
          </Button>
        </VStack>
      </VStack>
    </Modal>
  );
};

export default EReportLimitModal;


